import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import type { AppDispatch } from "store";
import { StarIcon } from "shared/ui";
import { selectFavoriteIndicators, addIndicator, toggleFavoriteIndicator } from "../../model";
import { INDICATORS } from "../config";

import styles from "../select-indicators/SelectIndicators.module.css";

export const FavoritesIndicatorsList: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const favorites = useSelector(selectFavoriteIndicators);

  const favoriteIndicators = INDICATORS.filter((ind) => favorites.includes(ind.name));

  if (favoriteIndicators.length === 0) {
    return <p className={styles.empty}>No favorites yet</p>;
  }

  return (
    <ul className={styles.list}>
      {favoriteIndicators.map((indicator) => (
        <li key={indicator.name} className={styles.item}>
          <button
            className={styles.starBtn}
            onClick={(e) => {
              e.stopPropagation();
              dispatch(toggleFavoriteIndicator(indicator.name));
            }}
            title="Remove from favorites"
          >
            <StarIcon className={styles.starIcon} fill="#F89706" />
          </button>
          <span
            className={styles.itemLabel}
            onClick={() => dispatch(addIndicator(indicator.name))}
          >
            {indicator.label}
          </span>
        </li>
      ))}
    </ul>
  );
};
